// extracted by mini-css-extract-plugin
module.exports = {"title":"CheckList_title__ge6n1","item":"CheckList_item__2clLW"};